import { History, createBrowserHistory } from 'history';
import { BASE_URL } from './app/common/constants';

const history: History = createBrowserHistory({ basename: BASE_URL });

export default history;
